import React from 'react'
import { SingleDatePicker } from '../../../components/Form'
import { getMessage } from '../../../lib/translator'
// Aliased: Dashboard/index.js has its own formatDate that goes the other way,
// Date -> YYYY-MM-DD. This one renders YYYY-MM-DD as '4th Aug 2026'.
import { formatDate as formatDisplayDate } from '../../../lib/datetime'

const RefreshIcon = () => (
  <svg
    className="od-icon"
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M21 12a9 9 0 11-2.64-6.36M21 3v6h-6"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

/**
 * Page heading plus the single date picker and refresh control. Both sections share
 * this date - the two per-section pickers the old table rendered could drift apart
 * visually even though they wrote to the same state.
 */
const DashboardHeader = ({
  isToday,
  selectedDate,
  onDateChange,
  onRefresh,
  areOrdersScheduled,
  isLoading,
}) => (
  <div className="od-page-header">
    <div className="od-page-header-text">
      <h1 className="od-title">{getMessage('operations.dashboard.heading')}</h1>
      <div className="od-subtitle">
        {isToday
          ? getMessage('operations.dashboard.subtitle.today')
          : getMessage('operations.dashboard.subtitle.date', {
              date: formatDisplayDate(selectedDate),
            })}
      </div>
    </div>
    <div className="od-page-header-actions">
      <div className="od-date-select">
        <SingleDatePicker
          allowAllDates={areOrdersScheduled ? true : undefined}
          isOutsideRange={!areOrdersScheduled ? true : undefined}
          displayFormat="YYYY-MM-DD"
          value={selectedDate}
          openDirection="down"
          onChange={onDateChange}
        />
      </div>
      <button
        type="button"
        className="od-icon-button"
        onClick={onRefresh}
        aria-label={getMessage('operations.dashboard.refresh')}
        title={getMessage('operations.dashboard.refresh')}
        data-testid="dashboard-refresh"
      >
        <span className={isLoading ? 'od-spin' : ''}>
          <RefreshIcon />
        </span>
      </button>
    </div>
  </div>
)

export default DashboardHeader
